<template>
  <v-sheet id="pdfContent" class="border-opacity-25 border-thin rounded-lg overflow-y-auto">
    <v-container>
      <div v-html="processedHtml"></div>
      <v-form v-model="isFormValid" @submit.prevent="onSubmit">
        <v-row v-for="inputField of inputFields">
          <v-col cols="12" md="12">
            <v-text-field
              v-if="!isSubmitted"
              v-model="formFields[inputField.title]"
              :label="inputField.title"
              :rules="[rules.required]"></v-text-field>
            <div v-else>{{ inputField.title }}: {{ formFields[inputField.title] }}</div>
          </v-col>
        </v-row>
        <v-row v-if="inputFields.length > 0">
          <v-divider></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="!isSubmitted"
              v-model="releaseForm.name"
              label="Name"
              :rules="[rules.required]"></v-text-field>
            <div v-else>Name: {{ releaseForm.name }}</div>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="!isSubmitted"
              v-model="releaseForm.address"
              label="Address"
              :rules="[rules.required]"></v-text-field>
            <div v-else>Address: {{ releaseForm.address }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="!isSubmitted"
              v-model="releaseForm.phone"
              label="Phone"
              :rules="[rules.phone, rules.required]"></v-text-field>
            <div v-else>Phone: {{ releaseForm.phone }}</div>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-if="!isSubmitted"
              v-model="releaseForm.email"
              label="Email"
              :rules="[rules.email, rules.required]"></v-text-field>
            <div v-else>Email: {{ releaseForm.email }}</div>
          </v-col>
        </v-row>
        <SignaturePadComponent
          :is-submitted="isSubmitted"
          title="Signature"
          @validateSignature="handleSignature">
        </SignaturePadComponent>
        <div v-if="!isSubmitted">
          <v-divider></v-divider>
          <v-btn block color="primary" outlined :disabled="!isFormValid || !isValid" type="submit">
            Submit Release
          </v-btn>
        </div>
        <div v-if="isSubmitted">
          <p class="p2"><b>Date:</b> {{ formFields.date }}</p>
          <p class="p2"><b>IPAddress:</b> {{ formFields.ipAddress }}</p>
          <p class="p2"><b>Browser:</b> {{ formFields.browser }}</p>
        </div>
      </v-form>
    </v-container>
  </v-sheet>
</template>
<script lang="ts" setup>
import { computed, nextTick, ref, watch } from 'vue';
import html2pdf from 'html2pdf.js';
import { IBaseFormFields, processedFormHTML, rules } from '@/helpers';
import SignaturePadComponent from '../ui/SignaturePadComponent.vue';
import { IFormTemplateDTO, IInputFieldsDTO } from '@/dtos';

interface Props {
  form?: IFormTemplateDTO;
  formFields: IBaseFormFields;
  inputFields?: IInputFieldsDTO[];
}

const emit = defineEmits(['sigCompleted']);
const props = defineProps<Props>();
const form = computed(() => props.form);
const inputFields = computed(() => props.inputFields || []);
const isFormValid = ref<boolean>(false);
const isSubmitted = ref<boolean>(false);
const isValid = ref<boolean>(false);
const handleSignature = (valid: boolean) => {
  isValid.value = valid;
};

const processedHtml = computed(() => processedFormHTML(form.value?.body || '', props.formFields));

const releaseForm = ref({
  name: '',
  address: '',
  phone: '',
  email: '',
});
const onSubmit = async () => {
  if (!isValid) {
    return;
  } else {
    isSubmitted.value = true;
  }
  await nextTick();
  var pdfContent = document.getElementById('pdfContent');
  const pdfBlob = await html2pdf().from(pdfContent).outputPdf('blob');
  pdfBlob.name = `${releaseForm.value.name}.pdf`;
  emit('sigCompleted', pdfBlob);
};

watch(
  () => props.formFields,
  () => {
    if (props.formFields.name) releaseForm.value.name = props.formFields.name as string;
    if (props.formFields.email) releaseForm.value.email = props.formFields.email as string;
  },
  { deep: true, immediate: true },
);
</script>
